<script>
  import { shuffle, slice } from 'lodash'
  export let fonts_to_display
  export let wordmark_to_display
  
  let max_font_count = 12
  let random_fonts = slice(shuffle(fonts_to_display), 0, max_font_count)
  let element
  let index_to_show = 0
  const random_degree = () => 3 * Math.round(Math.random()*3 - Math.random()*3)

  function handleMousemove(event) {
		index_to_show = Math.abs(Math.round((event.clientX - element.offsetLeft) * random_fonts.length / element.offsetWidth))
	}
</script>

<!-- If thre are no fonts, show a placeholder -->
{#if fonts_to_display.length === 0}
  <div class="bundle">
    <li 
        class="card empty"
        style="transform: rotate({random_degree()}deg) scale(0.9);">
          <span style="font-family: 'Raleway Dots', cursive;">{wordmark_to_display}</span>
        </li>
  </div>
{:else}
  <div class="bundle" bind:this={element} on:mousemove={handleMousemove}>
    {#each random_fonts as random_font, i}
      {#if i < max_font_count}
        <li 
        class="card" 
        class:top={index_to_show === i} 
        style="transform: rotate({random_degree()}deg) scale(0.9);">
          <span style="font-family: {'"'+random_font.postscript_name+'"'}, 'Raleway Dots', cursive;">{wordmark_to_display}</span>
          <small>{random_font.display_name}</small>
        </li>
      {/if}
    {/each}
  </div>
{/if}


<style>
  .bundle {
    position: relative;
    width: 34rem;
    height: 24rem;
    padding: 2rem;
  }
  
  .card {
    position: absolute;
    display: flex;
    flex-direction: column;
    width: 30rem;
    height: 20rem;
    align-items: center;
    justify-content: center;
    padding: 1rem 1rem 1.5rem;
    font-size: 1.1rem;  /* Base for font size multiplier */
    line-height: 3.5em;
    text-align: center;
    color: var(--c-text);
    background-color: var(--c-content-bg);
    border: 1px solid var(--c-pill-bg);
    transform-origin: center;
  }

  .card.empty {
    background-color: var(--c-pill-bg);
  }

  li span {
    font-size: 4rem;
    margin: auto;
  }
  li small {
    font-size: 1.3rem;
    line-height: 1.33em;
    letter-spacing: 0.02rem;
    color: var(--c-text-faded);
    text-decoration: none;
    white-space: nowrap;
  }

  .card.top {
    z-index: 2;
  }
</style>